// Account Payable Getters

export const getAccountPayableList = state => {
  return state.accountPayableList
}

export const getAccountPayableInfo = state => {
  return state.accountPayableInfo
}

export const getAccountPayableBalanceDetails = state => {
  return state.accountPayableBalanceDetails
}

export const getPaymentTypes = state => {
  return state.paymentTypes
}
